import { TECHNICIAN_APPOINTMENT_DASHBOARD_PAGE } from "../../../util/cfstPendoUtils";
import {
  RESET_APPOINTMENT_DETAILS,
  CONTACT_ADDRESS_RADIO_BUTTON_VALUE,
  ADDRESS_RADIO_BUTTON_VALUE,
  SET_CONTACT_DETAILS_FIELDS,
  SET_LOADER,
  SET_FEE,
  SET_STATES,
  GET_CONTACT_VALUES,
  SET_CONTACT_FORM_VALUES,
  SET_SERVICE_DETAILS,
  SET_ACCOUNT_DETAILS,
  SET_MATERIAL_LIST,
  SET_APPOINTMENT_PER_PAGE,
  SET_APPOINTMENT_TOTAL_NUMBER_OF_RECORDS,
  SET_APPOINTMENT_ACTIVE_PAGE,
  SET_ALL_APPOINTMENTS,
  FILTER_APPOINTMENT_LIST,
  SET_RESCHEDULE,
  SET_RESCHEDULE_APPOINTMENT_DETAILS,
  SET_SERVICE_TOTAL_FEES,
  SET_JOB_DURATION_DETAILS,
  SET_EST_APPOINTMENT_LENGTH,
  SET_ADDRESS_VALIDATION_RESPONSE,
  IS_VALIDATE_ADDRESS,
  SET_CASENUMBER,
  SET_CASE_SFDC_ID,
  SET_CASE_SUBJECT,
  SET_SLOT_DETAILS,
  GET_ADDRESS_VALUE,
  GET_EXISTING_ADDRESS_VALUE,
  SET_NOTES_TO_TECHNICIAN,
  SET_UPDATE_CASE_PAYLOAD,
  SET_RESCHEDULE_REASON_LIST,
  SET_JOB_RESP,
  SET_JOB_DETAILS,
  SET_UPDATE_JOB_PAYLOAD,
  SET_PREFERRED_DATE,
  SET_CONTACT_FORM_ERROR,
  SET_EDITED_CONTACT_FORM_VALUES,
  SET_MATERIAL_LIST_SKELTON_LOADER,
  SET_VEHICLE_AND_ASSET_LIST,
  ADDRESS_VALIDATION_API_CHECK,
  SET_CREATE_CASE_API_FAILURE,
  IS_ASSISTANCE_REQUIRED,
  SET_ASSISTANCE_CASE_DETAILS,
  SET_IS_UPDATE_CASE_API_FAILED,
  JOB_FAILURE,
  SET_IS_SCHEDULE_API_FAILED,
  SET_JOB_DETAILS_API_FAILED,
  IS_WITHIN_THREE_BUSINESS_DAYS,
  SET_JOB_DURATION_EXCEEDS_10_HRS,
  SET_CURRENT_PAGE,
  RESCHEDULE_SCHEDULING_NOTES,
  SET_RESCHEDULE_SCHEDULING_EMAIL,
  ACCESSORIES_LOADER,
  RESET_CONTACT_DETAILS_PAGE_DATA,
  IS_EXISTING_CONTACT_NAME_EDITED,
  IS_STATUS,
} from "../../actions/schedulingportal/technicianAppointment";

const initState = {
  serviceDetails: [],
  userSelectedContactOption: "",
  userSelectedAddressOption: "",
  fullName: "",
  emailAddress: "",
  mobileNumber: "",
  landlineNumber: "",
  loading: false,
  feeDetails: null,
  contactFormValues: {
    existingContact: {},
    newContact: {},
    selectedContactType: "",
  }, // temporary
  editedContactFormValues: {
    existingContact: {},
    newContact: {},
    selectedContactType: "",
  },
  addressFormValues: {
    existingAddress: {},
    newAddress: {
      inputAddress: {},
      standardizedInfo: {},
      newAddressLocation: {},
      formAddress: {},
      isLocationFound: false,
      addressByPass: null,
      addressFound: "",
    },
  }, // temporary
  firstName: "",
  lastName: "",
  email: "",
  contactId: "",
  contactType: "",
  isFieldsNotEmpty: true,
  appointmentList: [],
  filteredAppointmentsList: [],
  appointmentsPerPage: [],
  message: "",
  totalNumberOfRecords: 0,
  activePage: 0,
  recordsPerPage: 10,
  pageRangeDisplayed: 5,
  isReschedule: false,
  rescheduleAppointmentDetails: {},
  serviceTotalFees: 0,
  isSuggestedAddress: false,
  isContactFormError: false,
  isValidateAddressApi: true,
  statesData: {
    error: false,
    statesList: [],
  },
  jobDurationDetails: [],
  estAppointmentLength: 0,
  accountDetails: {
    error: false,
    data: {},
  }, //csp account details

  materialList: {
    error: null,
    skeltonLoader: false,
    data: [],
  },
  caseNumber: "",
  caseSfdcId: "",
  jobResponseData: {},
  jobDetails: null,
  jobDetailsApiFailed: false,
  caseSubject: "",
  notesToTechnician: "",
  selectedSlotDetails: {},
  updateCasePayloadOnSchedule: {},
  updateJob: {
    payload: {},
    isUpdated: false,
  },
  rescheduleReasons: { reasons: [], error: false },
  preferredDate: "",
  vehicleAndAssetList: { vehicles: [], error: null },
  dashboardLoader: false,
  isAssistanceRequired: false,
  isCreateCaseAPIFailed: null,
  agentAssistanceCaseDetails: {
    caseId: null,
    caseNumber: null,
  },
  isUpdateCaseApiFailed: false,
  APIFailure: {
    isJobFailure: false,
    error: "",
    isSlotsFailure: false,
    isTransactionFailure: false,
  },
  isScheduleApiFailed: false,
  isJobScheduleDateIsWithInThreeBusinessDays: false,
  isJobDurationExceeds10Hrs: false,
  currentPage: TECHNICIAN_APPOINTMENT_DASHBOARD_PAGE,
  rescheduleSchedulingNotes: "",
  rescheduleSchedulingEmail: "",
  accessoriesLoader: false,
  isExistingContactNameEdited: false,
  isStatus: null,
};

const technicianAppointmentReducer = (state = initState, action) => {
  switch (action.type) {
    case CONTACT_ADDRESS_RADIO_BUTTON_VALUE:
      return {
        ...state,
        userSelectedContactOption: action.value,
      };
    case ADDRESS_RADIO_BUTTON_VALUE:
      return {
        ...state,
        userSelectedAddressOption: action.value,
      };
    case SET_CONTACT_DETAILS_FIELDS: {
      const data = action.value?.selectedContactType === "add-new-contact" ? action.value?.newContact : action.value?.existingContact;
      return {
        ...state,
        ...data,
      };
    }
    case RESET_APPOINTMENT_DETAILS:
      return {
        ...state,
        serviceDetails: [],
        userSelectedContactOption: "",
        userSelectedAddressOption: "",
        fullName: "",
        emailAddress: "",
        mobileNumber: "",
        landlineNumber: "",
        isFieldsNotEmpty: true,
        isContactFormError: false,
        isReschedule: false,
        rescheduleAppointmentDetails: {},
        jobResponseData: {},
        caseSfdcId: "",
        caseSubject: "",
        notesToTechnician: "",
        selectedSlotDetails: {},
        inputAddress: {},
        standardizedInfo: {},
        isSuggestedAddress: false,
        isLocationFound: false,
        addressByPass: null,
        contactFormValues: { existingContact: {}, newContact: {}, selectedContactType: "" },
        editedContactFormValues: { existingContact: {}, newContact: {}, selectedContactType: "" },
        addressFormValues: {
          existingAddress: {},
          newAddress: {
            inputAddress: {},
            standardizedInfo: {},
            newAddressLocation: {},
            formAddress: {},
            isLocationFound: false,
            addressByPass: null,
            addressFound: "",
          },
        },
        isValidateAddressApi: true,
        updateCasePayloadOnSchedule: {},
        isAssistanceRequired: false,
        agentAssistanceCaseDetails: { caseId: null, caseNumber: null },
        isUpdateCaseApiFailed: false,
        preferredDate: "",
        isScheduleApiFailed: false,
        jobDetailsApiFailed: false,
        APIFailure: {
          isJobFailure: false,
          error: "",
          isSlotsFailure: false,
          isTransactionFailure: false,
        },
        isJobScheduleDateIsWithInThreeBusinessDays: false,
        rescheduleSchedulingNotes: "",
        rescheduleSchedulingEmail: "",
        accessoriesLoader: false,
      };
    case SET_LOADER:
      return {
        ...state,
        loading: action.value,
      };
    case SET_FEE:
      return {
        ...state,
        feeDetails: action.value,
      };
    case SET_JOB_DURATION_DETAILS:
      return {
        ...state,
        jobDurationDetails: action.value,
      };
    case SET_EST_APPOINTMENT_LENGTH:
      return {
        ...state,
        estAppointmentLength: action.value,
      };
    case SET_SERVICE_TOTAL_FEES:
      return {
        ...state,
        serviceTotalFees: action.value,
      };
    case SET_STATES:
      return {
        ...state,
        statesData: { statesList: action.value.statesList, error: action.value.error },
      };
    case GET_CONTACT_VALUES: //temporary
      return {
        ...state,
        contactFormValues: { ...action.value },
      };
    case GET_ADDRESS_VALUE:
      return {
        ...state,
        addressFormValues: {
          ...state.addressFormValues,
          newAddress: { ...state.addressFormValues.newAddress, formAddress: { ...action.value } },
        },
      };
    case GET_EXISTING_ADDRESS_VALUE:
      return {
        ...state,
        addressFormValues: { ...state.addressFormValues, existingAddress: { ...action.value } },
      };
    case SET_CONTACT_FORM_VALUES: // actual reducer for displaying
      return {
        ...state,
        ...action.value,
      };
    case SET_SERVICE_DETAILS:
      return {
        ...state,
        serviceDetails: [...action.serviceDetailsList],
      };
    case SET_ACCOUNT_DETAILS:
      return {
        ...state,
        accountDetails: { ...action.value },
      };
    case SET_MATERIAL_LIST:
      return {
        ...state,
        materialList: { ...action.value },
      };
    case SET_MATERIAL_LIST_SKELTON_LOADER:
      return {
        ...state,
        materialList: { ...state.materialList, skeltonLoader: action.value },
      };
    case SET_APPOINTMENT_PER_PAGE:
      return {
        ...state,
        appointmentsPerPage: action.value,
      };
    case SET_APPOINTMENT_TOTAL_NUMBER_OF_RECORDS:
      return {
        ...state,
        totalNumberOfRecords: action.value,
      };
    case SET_APPOINTMENT_ACTIVE_PAGE:
      return {
        ...state,
        activePage: action.value,
      };
    case SET_ALL_APPOINTMENTS:
      return {
        ...state,
        // loading: false,
        appointmentList: action.response,
        filteredAppointmentsList: action.response,
        totalNumberOfRecords: action.response.length,
        appointmentsPerPage: action.response.slice(0, 10),
        activePage: 1,
      };
    case FILTER_APPOINTMENT_LIST:
      return {
        ...state,
        filteredAppointmentsList: action.response,
        totalNumberOfRecords: action.response.length,
        appointmentsPerPage: action.response.slice(0, 10),
        activePage: 1,
      };
    case SET_RESCHEDULE:
      return {
        ...state,
        isReschedule: action.value,
      };
    case SET_RESCHEDULE_APPOINTMENT_DETAILS:
      return {
        ...state,
        rescheduleAppointmentDetails: action.value,
      };
    case SET_ADDRESS_VALIDATION_RESPONSE:
      return {
        ...state,
        addressFormValues: {
          ...JSON.parse(JSON.stringify(state.addressFormValues)),
          newAddress: {
            ...state.addressFormValues.newAddress,
            inputAddress: { ...action.response.inputAddress },
            standardizedInfo: { ...action.response.standardizedInfo },
            newAddressLocation: { ...action.response.location },
            isLocationFound: action.response.locationFound,
            addressByPass: action.response.addressByPass,
            addressFound: action.response.locationFound ? "" : "addressNotFound",
          },
        },
      };
    case ADDRESS_VALIDATION_API_CHECK:
      return { ...state, isValidateAddressApi: action.value };

    case IS_VALIDATE_ADDRESS:
      return {
        ...state,
        isSuggestedAddress: action.response,
      };
    case SET_CASENUMBER:
      return {
        ...state,
        caseNumber: action.value,
      };
    case SET_CASE_SFDC_ID:
      return {
        ...state,
        caseSfdcId: action.value,
      };
    case SET_CASE_SUBJECT:
      return {
        ...state,
        caseSubject: action.value,
      };
    case SET_SLOT_DETAILS:
      return {
        ...state,
        selectedSlotDetails: action.value,
      };
    case SET_NOTES_TO_TECHNICIAN:
      return {
        ...state,
        notesToTechnician: action.value,
      };
    case SET_UPDATE_CASE_PAYLOAD:
      return {
        ...state,
        updateCasePayloadOnSchedule: action.value,
      };
    case SET_UPDATE_JOB_PAYLOAD:
      return {
        ...state,
        updateJob: { ...action.value },
      };
    case SET_RESCHEDULE_REASON_LIST:
      return {
        ...state,
        rescheduleReasons: { ...action.value },
      };

    case SET_JOB_RESP:
      return {
        ...state,
        jobResponseData: action.value,
      };
    case SET_JOB_DETAILS:
      return {
        ...state,
        jobDetails: action.value,
      };
    case SET_JOB_DETAILS_API_FAILED:
      return {
        ...state,
        jobDetailsApiFailed: action.value,
      };
    case SET_PREFERRED_DATE:
      return {
        ...state,
        preferredDate: action.value,
      };

    case SET_CONTACT_FORM_ERROR:
      return {
        ...state,
        isContactFormError: action.value,
      };
    case SET_EDITED_CONTACT_FORM_VALUES:
      return {
        ...state,
        editedContactFormValues: action.value,
      };
    case SET_VEHICLE_AND_ASSET_LIST:
      return {
        ...state,
        vehicleAndAssetList: { ...action.value },
      };
    case SET_CREATE_CASE_API_FAILURE:
      return {
        ...state,
        isCreateCaseAPIFailed: action.value,
      };
    case IS_ASSISTANCE_REQUIRED:
      return {
        ...state,
        isAssistanceRequired: action.value,
      };
    case SET_ASSISTANCE_CASE_DETAILS:
      return {
        ...state,
        agentAssistanceCaseDetails: { ...action.value },
      };
    case SET_IS_UPDATE_CASE_API_FAILED:
      return {
        ...state,
        isUpdateCaseApiFailed: action.value,
      };
    case SET_IS_SCHEDULE_API_FAILED:
      return {
        ...state,
        isScheduleApiFailed: action.value,
      };
    case JOB_FAILURE:
      return {
        ...state,
        APIFailure: { ...action.value },
      };
    case IS_WITHIN_THREE_BUSINESS_DAYS:
      return {
        ...state,
        isJobScheduleDateIsWithInThreeBusinessDays: action.value,
      };
    case SET_JOB_DURATION_EXCEEDS_10_HRS:
      return {
        ...state,
        isJobDurationExceeds10Hrs: action.value,
      };
    case SET_CURRENT_PAGE:
      return {
        ...state,
        currentPage: action.value,
      };
    case RESCHEDULE_SCHEDULING_NOTES:
      return {
        ...state,
        rescheduleSchedulingNotes: action.value,
      };
    case SET_RESCHEDULE_SCHEDULING_EMAIL:
      return {
        ...state,
        rescheduleSchedulingEmail: action.value,
      };
    case RESET_CONTACT_DETAILS_PAGE_DATA:
      return {
        ...state,
        userSelectedContactOption: "",
        userSelectedAddressOption: "",
        fullName: "",
        emailAddress: "",
        mobileNumber: "",
        landlineNumber: "",
        isFieldsNotEmpty: true,
        isContactFormError: false,
        notesToTechnician: "",
        inputAddress: {},
        standardizedInfo: {},
        isSuggestedAddress: false,
        isLocationFound: false,
        addressByPass: null,
        contactFormValues: { existingContact: {}, newContact: {}, selectedContactType: "" },
        editedContactFormValues: { existingContact: {}, newContact: {}, selectedContactType: "" },
        addressFormValues: {
          existingAddress: {},
          newAddress: {
            inputAddress: {},
            standardizedInfo: {},
            newAddressLocation: {},
            formAddress: {},
            isLocationFound: false,
            addressByPass: null,
            addressFound: "",
          },
        },
        isValidateAddressApi: true,
        isExistingContactNameEdited: false,
      };
    case ACCESSORIES_LOADER:
      return {
        ...state,
        accessoriesLoader: action.value,
      };
    case IS_EXISTING_CONTACT_NAME_EDITED:
      return {
        ...state,
        isExistingContactNameEdited: action.value,
      };
    case IS_STATUS:
      return {
        ...state,
        isStatus: action.value,
      };
    default:
      return state;
  }
};

export default technicianAppointmentReducer;
